import type { ResolvedRichTextValue, RichTextElementProps } from "@/modules/kontent/types"

import { extractTextsFromRichTextElements } from "@/modules/kontent/textsFromRichTextElements"

export type Heading = {
  id: string
  name: string
  tagName: "h1" | "h2" | "h3" | "h4" | "h5" | "h6"
}

function updateHeadingInRichTextElement(
  elementProps: RichTextElementProps,
  headingList: Heading[] = [],
  headingsToFind: Heading["tagName"][] = []
): [RichTextElementProps, Heading[]] {
  if (elementProps.type === "tag") {
    if (headingsToFind.includes(elementProps.tagName as Heading["tagName"])) {
      const textsFromRichTextElements = extractTextsFromRichTextElements(elementProps.children || [])
      const safeTextsFromRichTextElements = textsFromRichTextElements.map(text =>
        text.toLowerCase().replace(/[^a-z]/g, "_")
      )

      if (textsFromRichTextElements.length) {
        const id = safeTextsFromRichTextElements.join("_")

        headingList.push({
          id,
          name: textsFromRichTextElements.join(" "),
          tagName: elementProps.tagName as Heading["tagName"],
        })

        // @ts-expect-error The `style` attribute is messing the type.
        // eslint-disable-next-line no-param-reassign
        elementProps.attributes = {
          ...elementProps.attributes,
          id,
        }
      }
    } else if (elementProps.children) {
      const [updatedChildren] = updateRichTextHeadings(elementProps.children, headingList, headingsToFind)
      // eslint-disable-next-line no-param-reassign
      elementProps.children = updatedChildren
    }
  }

  return [elementProps, headingList]
}

export function updateRichTextHeadings(
  value: ResolvedRichTextValue,
  headingList: Heading[] = [],
  headingsToFind: Heading["tagName"][] = ["h2", "h3"]
): [ResolvedRichTextValue, Heading[]] {
  return [
    value.map(elementProps => {
      const [updatedElementProps] = updateHeadingInRichTextElement(elementProps, headingList, headingsToFind)
      return updatedElementProps
    }),
    headingList,
  ]
}
